import { Component, computed, inject } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { AuditService } from '../../core/services/audit.service';
import { AuthService } from '../../core/services/auth.service';
import { ConfigService } from '../../core/services/config.service';
import { DeployUrlPipe } from '../../core/pipes/deploy-url.pipe';

@Component({
  selector: 'cwo-external-sign-in',
  standalone: true,
  imports: [TranslocoDirective, DeployUrlPipe],
  templateUrl: './external-sign-in.component.html',
  styleUrl: './external-sign-in.component.scss',
})
export class ExternalSignInComponent {
  private configService = inject(ConfigService);
  private authService = inject(AuthService);
  private auditService = inject(AuditService);

  supportsGoogleSignIn = computed(() => !!this.configService.configState().store?.supportsGoogleSignIn);
  supportsAppleSignIn = computed(() => !!this.configService.configState().store?.supportsAppleSignIn);

  handleGoogleSignIn() {
    this.auditService.createAudit(() => "\"Sign in with Google\" button clicked.");
    this.authService.startExternalSignIn('google');
  }

  handleAppleSignIn() {
    this.auditService.createAudit(() => "\"Sign in with Apple\" button clicked.");
    this.authService.startExternalSignIn('apple');
  }
}
